// @ngInject
function BarcodeService() {
    return {
        cleanBarcode: cleanBarcode,
        formatBarcodesString: formatBarcodesString
    };

    function cleanBarcode(barcode) {
        var cleanedBarcode = barcode;

        cleanedBarcode = cleanedBarcode.replace(/#/g, '');
        cleanedBarcode = cleanedBarcode.replace(/p/gi, '');

        cleanedBarcode = cleanedBarcode.trim();

        return cleanedBarcode;
    }

    function formatBarcodesString(string) {
        var formattedString = string;

        formattedString = formattedString.replace(/##/g, '\n');
        formattedString = formattedString.replace(/#/g, '');
        formattedString = formattedString.replace(/p/gi, '');

        return formattedString;
    }
}

angular
    .module('services.barcodeService', [])
    .factory('BarcodeService', BarcodeService);
